import {
  COOKIE_OPTIONS,
  COOKIE_MANAGER_ACCESS_TOKEN_NAME,
  COOKIE_MANAGER_REFRESH_TOKEN_NAME
} from "constants/common";
import { useCookies } from "react-cookie";

const useManagerAuthTokens = () => {
  const [cookie, setCookie, removeCookie] = useCookies();

  const setTokens = (accessToken: string, refreshToken: string) => {
    setCookie(COOKIE_MANAGER_ACCESS_TOKEN_NAME, accessToken, COOKIE_OPTIONS);
    setCookie(COOKIE_MANAGER_REFRESH_TOKEN_NAME, refreshToken, COOKIE_OPTIONS);
  };

  const removeTokens = () => {
    removeCookie(COOKIE_MANAGER_ACCESS_TOKEN_NAME, COOKIE_OPTIONS);
    removeCookie(COOKIE_MANAGER_REFRESH_TOKEN_NAME, COOKIE_OPTIONS);
  };

  return {
    accessToken: cookie[COOKIE_MANAGER_ACCESS_TOKEN_NAME],
    refreshToken: cookie[COOKIE_MANAGER_REFRESH_TOKEN_NAME],
    setTokens,
    removeTokens
  };
};

export default useManagerAuthTokens;
